module.exports = __webpack_public_path__ + "img/海空运跟踪查询.ffe0f561.png";